export enum TasksTemplatesApiTag {
  folder = "folder",
  template = "template",
}
